import type { LOAN_REQUEST_OFFER_SOURCE } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaAcceptedOffersCommon } from '../tables';

type Arguments = {
    id: string;
    source: LOAN_REQUEST_OFFER_SOURCE;
};
export const schemaLoanRequestResolver_GetOffersAcceptanceStatusByLoanRequestId = z.array(
    z.object({
        acceptanceStatus: schemaAcceptedOffersCommon.shape.acceptanceStatus.nullable(),
        id: z.string(),
    }),
);

export type SchemaLoanRequestResolver_GetOffersAcceptanceStatusByLoanRequestId = z.infer<
    typeof schemaLoanRequestResolver_GetOffersAcceptanceStatusByLoanRequestId
>;

export type LoanRequestResolver_GetOffersAcceptanceStatusByLoanRequestId = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetOffersAcceptanceStatusByLoanRequestId
>;
